import { Parte } from "../../types";
import CardParteProcesso from "./CardParteProcesso";
import CardParteRepresentada from "./CardParteRepresentada";

interface BlocoPartesProps {
    partes: Parte[];
}

export default function BlocoPartes({ partes }: BlocoPartesProps) {
    if (partes.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">Partes</h4>
            <div className="partes-container">
                {partes.map((parte, idx) => {
                    const isParteRepresentada = parte.tipo === 'PARTE REPRESENTADA';
                    const key = `${parte.tipo}-${parte.nome}-${idx}`;
                    
                    return (
                        <div key={key} className="parte-item">
                            {isParteRepresentada ? (
                                <CardParteRepresentada parte={parte} />
                            ) : (
                                <CardParteProcesso parte={parte} />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

